import { useWizard } from '../../../context/WizardContext';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import type { QuestionVersion } from '../../../types/wizard';
import { cn } from '../../../lib/utils';
import { Check } from 'lucide-react';

const VERSIONS: { value: QuestionVersion; label: string; sublabel: string; flag: string }[] = [
  { value: 'Bangla', label: 'বাংলা ভার্সন', sublabel: 'Bangla Medium', flag: '🇧🇩' },
  { value: 'English', label: 'English Version', sublabel: 'ইংরেজি মাধ্যম', flag: '🇬🇧' },
];

export function Step0Version() {
  const { state, setVersion } = useWizard();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select Version</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose the medium in which questions will be generated.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {VERSIONS.map((v) => {
          const isSelected = state.selectedVersion === v.value;
          return (
            <button
              key={v.value}
              type="button"
              onClick={() => setVersion(v.value)}
              className={cn(
                'relative flex flex-col items-center gap-4 rounded-2xl border-2 p-8 transition-all duration-200 focus:outline-none group',
                isSelected
                  ? 'border-transparent bg-brand-50 ring-2 ring-brand-300 shadow-md'
                  : 'border-slate-700 bg-slate-700/50 hover:border-slate-600 hover:shadow-card-hover hover:-translate-y-0.5'
              )}
            >
              {isSelected && (
                <span className="absolute top-3 right-3 flex h-5 w-5 items-center justify-center rounded-full bg-brand-600 text-white">
                  <Check className="h-3 w-3" strokeWidth={3} />
                </span>
              )}
              <span className="text-5xl">{v.flag}</span>
              <div className="text-center">
                <p
                  className={cn('text-xl font-bold', isSelected ? 'text-violet-300' : 'text-white')}
                >
                  {v.label}
                </p>
                <p className="text-sm text-slate-500 mt-1">{v.sublabel}</p>
              </div>
            </button>
          );
        })}
      </div>

      <NavigationButtons />
    </div>
  );
}
